var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38,38v4H10V38H38ZM36.9141,22.9141l-2.8282-2.8282L26,28.1714V7H22V28.1714l-8.0859-8.0855-2.8282,2.8282L24,35.8286Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRgbRed);
export default __webpack_public_path__ + "static/media/download_rgb_red.ab38d4cce98ebd057d5ce5c80afb571f.svg";
export { ForwardRef as ReactComponent };